import { useState, useRef, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { extractPublicId, cldAvatar } from '@/utils/media';

interface FeedOptimizedAvatarProps {
  src?: string | null;
  alt: string;
  fallback: string;
  className?: string;
}

export const FeedOptimizedAvatar = ({ 
  src, 
  alt, 
  fallback, 
  className 
}: FeedOptimizedAvatarProps) => {
  const [optimizedSrc, setOptimizedSrc] = useState<string | undefined>(undefined);
  const [isCloudinaryUrl, setIsCloudinaryUrl] = useState(false);

  useEffect(() => {
    if (!src) {
      setOptimizedSrc(undefined);
      return;
    }

    // Check if it's a Cloudinary URL
    if (src && src.includes('cloudinary.com')) {
      setIsCloudinaryUrl(true);
      const publicId = extractPublicId(src);
      // Use optimized avatar URL with size cap
      setOptimizedSrc(cldAvatar(publicId, 64));
    } else {
      setIsCloudinaryUrl(false);
      setOptimizedSrc(src);
    }
  }, [src]);

  return (
    <Avatar className={className}>
      {optimizedSrc && (
        <AvatarImage 
          src={optimizedSrc} 
          alt={alt}
          loading="lazy"
          decoding="async"
        />
      )}
      <AvatarFallback className="text-xs font-semibold bg-gradient-to-br from-green-100 to-blue-100 text-green-800">
        {fallback}
      </AvatarFallback>
    </Avatar>
  );
};